import { doc, getDoc, setDoc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { UserSettings, UpdateSettingsInput } from '../models/Settings';

/**
 * Gets user settings
 */
export async function getUserSettings(userId: string): Promise<UserSettings | null> {
  const docRef = doc(db, 'settings', userId);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) {
    return null;
  }

  const data = docSnap.data();
  const now = new Date();
  
  return {
    id: docSnap.id,
    ...data,
    createdAt: data.createdAt?.toDate() || now,
    updatedAt: data.updatedAt?.toDate() || now,
  } as UserSettings;
}

/**
 * Creates or updates user settings
 */
export async function updateUserSettings(userId: string, settings: UpdateSettingsInput): Promise<void> {
  const docRef = doc(db, 'settings', userId);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) {
    // Create new settings
    const now = Timestamp.now();
    await setDoc(docRef, {
      userId,
      ...settings,
      createdAt: now,
      updatedAt: now,
    });
  } else {
    // Update existing settings
    await updateDoc(docRef, {
      ...settings,
      updatedAt: Timestamp.now(),
    });
  }
} 